import React from 'react';
import AnimatronicCard from './AnimatronicCard';
import Pagination from '../ui/Pagination';
import type { Animatronic } from '../../types/animatronic';

interface AnimatronicGridProps {
  animatronics: Animatronic[];
  currentPage: number;
  onPageChange: (page: number) => void;
  itemsPerPage?: number;
}

const AnimatronicGrid: React.FC<AnimatronicGridProps> = ({
  animatronics,
  currentPage,
  onPageChange,
  itemsPerPage = 12
}) => {
  const totalPages = Math.ceil(animatronics.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentAnimatronics = animatronics.slice(startIndex, endIndex);

  const handlePageChange = (page: number) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    onPageChange(page);
  };

  if (currentAnimatronics.length === 0) {
    return (
      <div className="text-center py-12 text-content-secondary">
        No animatronics found matching your criteria
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {currentAnimatronics.map((animatronic) => (
          <div key={animatronic.id} className="h-full">
            <AnimatronicCard animatronic={animatronic} />
          </div>
        ))}
      </div>

      {totalPages > 1 && (
        <div className="py-4 sm:py-6">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      )}
    </div>
  );
};

export default AnimatronicGrid;